module.exports = __webpack_public_path__ + "img/LOGO_2305_1_2.5e88f947.svg";